var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 61,
    viewBox: "0 0 92 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8674_3580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7156 52.5694V54.3736H89.4384V58.6957H2.06164V54.3736H41.7655V57.4368H49.7285V54.3736H82.0792V0.5H9.47713L9.47114 48.8284H11.2828V2.30426H80.2652V52.5694H0.25V60.5H91.25V52.5694H85.7156ZM47.9205 55.6326H43.5807V54.3736H47.9205V55.6326Z",
    fill: "#161516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0874 5.0957V49.781H77.4108V5.0957H14.0874ZM75.5968 47.9767H15.9014V6.89996H75.5992L75.5968 47.9767Z",
    fill: "#161516"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8674_3580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 60,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.3fe896800424cadde5e488bc7acfe19e.svg";
export { ForwardRef as ReactComponent };